import { Phone, MapPin } from "lucide-react";
import Logo from "./Logo";
import { HOTEL, NAV_LINKS } from "../data/content";
import { scrollToHash } from "./Navbar";

const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-[#2A2421] bg-[#0D0B0A]">
    <div className="mx-auto grid max-w-7xl gap-10 px-5 py-16 sm:px-8 md:grid-cols-3">
      <div>
        <Logo />
        <p className="mt-5 max-w-xs text-sm leading-relaxed text-[#78716C]">
          A boutique sanctuary of Kashmiri walnut craft and warm hospitality, on Hyderpora Bypass, Srinagar.
        </p>
      </div>
      <div>
        <p className="text-[10px] font-medium uppercase tracking-[0.3em] text-[#8C713B]">Explore</p>
        <div className="mt-4 flex flex-col gap-3">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`footer-link-${l.label.toLowerCase()}`}
              onClick={(e) => {
                e.preventDefault();
                scrollToHash(l.href);
              }}
              className="text-sm text-[#A8A29E] transition-colors hover:text-[#C5A059]"
            >
              {l.label}
            </a>
          ))}
        </div>
      </div>
      <div>
        <p className="text-[10px] font-medium uppercase tracking-[0.3em] text-[#8C713B]">Reach Us</p>
        <a href={HOTEL.phoneLink} data-testid="footer-phone-link" className="mt-4 flex items-center gap-3 text-sm text-[#A8A29E] transition-colors hover:text-[#C5A059]">
          <Phone size={14} className="text-[#C5A059]" /> {HOTEL.phoneDisplay}
        </a>
        <p className="mt-3 flex items-start gap-3 text-sm text-[#A8A29E]">
          <MapPin size={14} className="mt-1 shrink-0 text-[#C5A059]" /> {HOTEL.address}
        </p>
      </div>
    </div>
    <div className="border-t border-[#2A2421]">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-5 py-6 text-[10px] uppercase tracking-[0.25em] text-[#57534E] sm:flex-row sm:px-8">
        <p>© 2026 The Rayan · Srinagar</p>
        <p>Crafted with pride in Kashmir</p>
        <a href="/admin" data-testid="footer-admin-link" className="transition-colors hover:text-[#C5A059]">
          Hotel Login
        </a>
      </div>
    </div>
  </footer>
);

export default Footer;
